import React from 'react';

import ResourceType from '../../../utils/resource-types';
import DigestCategories from '../../../utils/digest-categories';
import * as VideoWatchPolicy from '../../../utils/video-watch-policy';
import Accordion from '../../accordion/accordion';
import ListWrapper from './list-wrapper';
import ConfirmationModal from '../../confirmation-modal/confirmation-modal';
import UploadingModal from '../../uploading-modal/uploading-modal';
import VideoModal from './video-modal';
import AudioModal from './audio-modal';
import { areItemActivitiesComplete, isActivity } from '../../../utils/tcc-utils';
import { FileTypes, readFile, SelectFile } from '../../file-uploader/file-uploader';
import moment from 'moment';
import activityContentTypes from '../../../utils/activity-content-types';

export default class ItemList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activities: this.props.activities,
            onConfirm: null,
            subItem: null,
            showUploading: false,
        };
    }

    setShowingUpload = bool => {
        this.setState({ showUploading: bool });
    }

    render() {
        const { card, links, activities = {}, isActivity } = this.props;
        return (
            <ListWrapper
                {...this.props}
                {...card} links={links} isActivity={isActivity}
            >
                <ItemListAccordion setShowingUpload={ this.setShowingUpload } showUploading={ this.state.showUploading } {...this.props} activities={activities} />

            </ListWrapper>
        );
    }
}

class ItemListAccordion extends React.Component {

    state = {
        activities: this.props.activities,
        onConfirm: null,
        subItem: null,
    };

    componentWillReceiveProps(nextProps) {
        const changed = Object.keys(this.state.activities)
            .filter(k => this.state.activities[k] !== nextProps.activities[k])
            .reduce((result, item) => ({ ...result, ...{ [item]: this.state.activities[item] } }), {});

        if (nextProps.activities !== this.props.activities && this.state.activities !== nextProps.activities) {
            this.setState({ activities: { ...nextProps.activities, ...changed } });
        }
    }

    render() {
        const { card, onClickItemAttach = ()=> null, classId = '' } = this.props;
        const items = card.items
            .map((item, itemIndex) => {
                const value = this.editableItem(item, itemIndex);
                const subItems = item.items
                    .map((subItem) => this.editableSubItem(
                        subItem,
                        card.id,
                        onClickItemAttach,
                        classId
                    ));
                return { ...item, value, items: subItems };
            });

        if ( this.props.showUploading ) {
            document.body.classList.add('modal-open');
        } else {
            if (document.body.classList.contains('modal-open')) {
                document.body.classList.remove('modal-open');
            }
        }

        return (
            <React.Fragment>
                { (card.neededCount) &&
                    <span className='needed-info'>* Atividades Obrigatórias</span>
                }
                <div className='section-accordion'>
                    <Accordion showSelect={ true } keyToSort={ 'title' } sections={items}/>
                </div>
                { this.props.showUploading && <UploadingModal show={ this.props.showUploading } />}
                {this.state.onConfirm &&
                <ConfirmationModal
                    show={true}
                    onClose={() => this.setState({ onConfirm: null })}
                    onConfirm={this.state.onConfirm}
                />
                }
            </React.Fragment>
        );
    }

    editableItem = (item, itemIndex) => {
        const isNeeded = (itemIndex + 1) <= this.props.card.neededCount;
        return (
            <React.Fragment>
                {isActivity(item) && <span className={isNeeded ? 'needed-item' : ''}>{itemIndex + 1}.</span>}
                {isActivity(item) && areItemActivitiesComplete(item, this.state.activities) &&
                <i className={`fa fa-check-circle ${isNeeded ? 'needed-item' : '' }`}/>}
                <span className={`panel-custom-header accordion-input ${ isNeeded ? 'needed-item-input' : ''}`} title={ item.title }>{ isNeeded ? `${item.title} *` : item.title }</span>
            </React.Fragment>
        );
    };

    editableSubItem = (subItem, idParent, onClickAttach, classId ) => {
        return (
            <React.Fragment>
                {this.renderSubItem(subItem, idParent, onClickAttach, classId )}
            </React.Fragment>
        );
    };

    renderSubItem = (item, idParent, onClickAttach, classId) => {
        switch (item.type) {
            case ResourceType.DIGEST:
                return <DigestContentSubItem {...item}/>;

            case ResourceType.VIDEO:
                return <VideoContentSubItem
                    {...item}
                    videosData={this.props.videosData}
                    initVideoData={this.props.initVideoData}
                    updateVideoData={this.props.updateVideoData}
                />;

            case ResourceType.AUDIO:
                return <AudioContentSubItem {...item}/>;

            case ResourceType.ACTIVITY:
                return <ActivityContentSubItem
                    {...item}
                    activity={this.state.activities[item.id]}
                    originalActivity={this.props.activities[item.id]}
                    handleChange={this.textAreaOnChange}
                    handleSave={this.props.updateActivity}
                    uploadFile={this.props.uploadFile}
                    setShowingUpload={ this.props.setShowingUpload }
                    onConfirmDelete={action => this.setState({ onConfirm: action })}
                    isSubmitted={this.props.isSubmitted}
                    pending={this.props.pending[`${this.props[this.props.idProp]}:${item.id}`]}
                />;

            case ResourceType.LIVE_LESSON:
                return (moment().isBetween(moment(item.init), moment(item.end))) ?
                    <LiveLessonContentSubItem{...item}/> : null;

            default:
                item.parent = idParent;
                item.onClickAttach = onClickAttach;
                item.classId = classId;
                return <LinkContentSubItem {...item} />;
        }
    };

    textAreaOnChange = ({ name, value }) => {
        this.setState({ activities: { ...this.state.activities, [name]: value } });
    };
}

class VideoContentSubItem extends React.Component {

    state = {
        video: null,
    };

    closeModal = () => this.setState({ video: null });

    render() {
        const { url, title, type, text = '', videosData } = this.props;
        const { video } = this.state;
        const viewedVideo = videosData[url] && VideoWatchPolicy.hasBeenSawn(videosData[url].segments);
        const videoTitleClass = !videosData[url] ? 'new-video' : 'opened-video';

        return (
            <div className='flex-vertical'>
                <div onClick={() => this.setState({ video: url })} style={{ cursor: 'pointer' }}>
                    <div className={`item-wrapper ${videoTitleClass}`}>
                        <div className='type-icon'><i className={icons[type]}/></div>
                        <div>{title}</div>
                        {viewedVideo && <i className=' viewed-icon fa fa-check-circle'/>}
                    </div>
                </div>
                <div className='important-text'>
                    {text && (text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
                </div>
                {video && <VideoModal
                    videoUrl={video}
                    videoData={videosData[video]}
                    onClose={this.closeModal}
                    initVideoData={this.props.initVideoData}
                    updateVideoData={this.props.updateVideoData}
                />}
            </div>
        );
    }
}

class AudioContentSubItem extends React.Component {

    state = {
        audio: null,
    };

    render() {
        const { url, title, type, text = '' } = this.props;
        const { audio } = this.state;

        return (
            <div className='flex-vertical'>
                <div onClick={() => this.setState({ audio: url })} style={{ cursor: 'pointer' }}>
                    <div className='item-wrapper'>
                        <div className='type-icon'><i className={icons[type]}/></div>
                        <div>{title}</div>
                    </div>
                </div>
                <div className='important-text'>
                    {text && (text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
                </div>
                {audio &&
                <AudioModal
                    playerUrl={audio}
                    onClose={() => this.setState({ audio: null })}
                />}
            </div>
        );
    }
}

const DigestContentSubItem = ({ category, title, text }) => (
    <div className='important-item'>
        <p className='important-title'>
            <i className={`important-icon ${icons[category]}`}/>{title}
        </p>
        <div className='important-text'>
            {(text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
        </div>
    </div>
);

const LinkContentSubItem = ({ url, title, type, text = '', parent = null, onClickAttach, id = '', classId }) => {
    if ( parent && String(parent).toLowerCase() === 'anexos') {
        return (
            <div className='flex-vertical'>
                <section className='attach-item' onClick={ ()=> onClickAttach(classId, id) }>
                    <div className='item-wrapper'>
                        <div className='type-icon'><i className={icons[type]}/></div>
                        <div>{title}</div>
                    </div>
                </section>
                <div className='important-text'>
                    {text && (text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
                </div>
            </div>
        );
    } else {
        return (
            <div className='flex-vertical'>
                <a href={url} download={type !== ResourceType.LINK} target='_blank'>
                    <div className='item-wrapper'>
                        <div className='type-icon'><i className={icons[type]}/></div>
                        <div>{title}</div>
                    </div>
                </a>
                <div className='important-text'>
                    {text && (text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
                </div>
            </div>
        );
    }
};

const ActivityContentSubItem = ({
    id,
    handleChange,
    handleSave,
    originalActivity = {},
    activity = {},
    uploadFile,
    setShowingUpload,
    onConfirmDelete,
    activityContentType = activityContentTypes.JUST_TEXT,
    isSubmitted,
    pending,
}) => {
    const hasChangeToSave = originalActivity.value !== activity.value || originalActivity.attachments !== activity.attachments;
    const isSaving = pending;
    const onChange = ({ target }) => {
        const name = target.name;
        const value = { ...activity, value: target.value };
        handleChange({ name, value });
    };
    const handleFileSelection = async (file) => {

        const attachments = activity.attachments || {};
        const attachmentId = Math.max(0, ...Object.keys(attachments)) + 1;
        const result = await readFile(file);
        setShowingUpload(true);
        uploadFile(result, url => {
            const attachment = { [attachmentId]: { title: file.name, url } };
            const updatedActivity = { ...activity, attachments: { ...attachments, ...attachment } };
            handleChange({ name: id, value: updatedActivity });
            handleSave({ [id]: updatedActivity });
            setShowingUpload(false);
        }, file.type);
    };
    const handleAttDelete = attachmentId => {
        const attachments = { ...(activity.attachments || {}) };
        if (!attachments[attachmentId]) {
            attachments[attachmentId] = {};
        }
        attachments[attachmentId].removed = true;
        const updatedActivity = { ...activity, attachments };
        handleChange({ name: id, value: updatedActivity });
        handleSave({ [id]: updatedActivity });
    };

    const showTextField = [activityContentTypes.JUST_TEXT, activityContentTypes.TEXT_AND_ATTACHMENT, activityContentTypes.SMALL_TEXT]
        .includes(activityContentType);

    const showAttachmentsField = activityContentType === activityContentTypes.JUST_ATTACHMENT ||
        activityContentType === activityContentTypes.TEXT_AND_ATTACHMENT;

    return (
        <React.Fragment>
            <div className='activity-content'>
                {showTextField &&
                    <div className='learning-item'>
                        <textarea
                            name={id} value={activity.value || ''} onChange={onChange}
                            onBlur={() => hasChangeToSave && handleSave({ [id]: activity })} disabled={isSubmitted || isSaving}/>
                    </div>
                }
                <div className='attachments-list'>
                    {Object
                        .keys(activity.attachments || {})
                        .filter(attachmentId => activity.attachments[attachmentId].removed !== true)
                        .map(attachmentId => (
                            <div key={attachmentId} className='attachment-item'>
                                <a href={activity.attachments[attachmentId].url} target='_blank'>
                                    {activity.attachments[attachmentId].title}
                                </a>
                                {!isSubmitted && <i
                                    className='fa fa-trash'
                                    onClick={() => onConfirmDelete(() => handleAttDelete(attachmentId))}
                                    title='Remover anexo'
                                />}
                            </div>
                        ))}
                </div>
            </div>
            <div className='activity-toolbar'>
                <button
                    disabled={!hasChangeToSave || isSaving}
                    title='Salvar alterações' className='activity-btn'
                    onClick={() => handleSave({ [id]: activity })}
                >
                    {isSaving ? 'Salvando' : 'Salvar'}
                </button>
                {showAttachmentsField &&
                    <SelectFile
                        accept={[FileTypes.PdfFile, FileTypes.Image, FileTypes.DocxFile]}
                        onChange={handleFileSelection}
                        disabled={isSubmitted}
                    >
                        <button title='Anexar arquivo' className='activity-btn' disabled={isSubmitted}>
                            <i className='fa fa-paperclip'/>
                        </button>
                    </SelectFile>
                }
            </div>
        </React.Fragment>
    );
};

const LiveLessonContentSubItem = ({ url, title, type }) => (
    <div className='flex-vertical'>
        <a href={url} target='_blank'>
            <div className='item-wrapper'>
                <div className='type-icon'><i className={icons[type]}/></div>
                <div>{title}</div>
            </div>
        </a>
    </div>
);

const icons = {
    [ResourceType.VIDEO]: 'fa fa-video-camera',
    [ResourceType.AUDIO]: 'fa fa-music',
    [ResourceType.FILE]: 'fa fa-file-text',
    [ResourceType.LINK]: 'fa fa-external-link',
    [ResourceType.LIVE_LESSON]: 'fa fa-television',
    [DigestCategories.BOOK]: 'fa fa-bookmark',
    [DigestCategories.MOVIE]: 'fa fa-film',
    [DigestCategories.ROUTINE]: 'fa fa-calendar',
    [DigestCategories.DYNAMIC]: 'fa fa-check',
    [DigestCategories.QUESTION]: 'fa fa-question-circle',
};



// WEBPACK FOOTER //
// ./src/components/section/components/item-list.js